import styled, { css } from 'styled-components';

import { Flex } from '@/components/Flex';

import { Grid } from '../Grid';
import { Typography } from '../Typography';

export const Container = styled(Flex)`
  max-width: 500px;
  flex-direction: column;
`;

export const TermButton = styled(Flex)<{
  isMobile: boolean;
  isSelected: boolean;
}>`
  width: 100%;
  text-transform: uppercase;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  background: ${({ isSelected, theme }) =>
    isSelected ? theme.colors.primaryBlue : theme.colors.lightGrey};
  cursor: pointer;
  transition-property: background-color, color;
  transition-duration: 0.3s;
  word-break: break-word;
  &:hover {
    background-color: ${({ theme }) => theme.colors.primaryBlue};
    color: ${({ theme }) => theme.colors.white};
  }

  ${({ isSelected, theme }) => css`
    color: ${theme.colors.primaryBlue};
    font-weight: ${theme.fontWeights.bold};
    padding: ${theme.spacing(1, 0.5)};

    ${isSelected &&
    css`
      background-color: ${theme.colors.primaryBlue};
      color: ${theme.colors.white};
    `}
  `}
`;

export const MonthlyPaymentsBox = styled(Flex)`
  flex-direction: column;
  padding: ${({ theme }) => theme.spacing(3)};
  background-color: ${({ theme }) => theme.colors.mediumGrey};
`;

export const TermsGrid = styled(Grid)<{ $colNum: number }>`
  ${({ $colNum, theme }) => css`
    grid-gap: 0px;
    grid-template-columns: 1fr;
    ${theme.media.md.up} {
      grid-template-columns: repeat(${$colNum}, 1fr);
    }
  `}
`;

export const BenefitList = styled.ul`
  list-style: disc;
  margin-left: ${({ theme }) => theme.spacing(3)};
  margin-bottom: ${({ theme }) => theme.spacing(3)};
`;

export const Month = styled(Typography)`
  ${({ theme }) => css`
    white-space: nowrap;
    ${theme.media.md.down} {
      font-size: ${theme.fontSizes.p3};
    }
  `}
`;
